
import './../../components/atoms/background-image/background-image.js'
import './../../components/atoms/picture/picture.js'
import './../../components/atoms/scroll-down/scroll-down.js'
import './../../components/atoms/scroll-to-top/scroll-to-top.js'
import './../../components/organisms/article-accordeon/article-accordeon.js'
import './../../components/organisms/article-chart/article-chart.js'
import './../../components/organisms/article-content-table/article-content-table.js'
import './../../components/organisms/chapter-content-table/chapter-content-table.js'
import './../../components/organisms/chapter-side-list/chapter-side-list.js'
import './../../components/organisms/product-form/product-form.js'
import './../../components/structures/balloons/balloons.js'
import './../../components/structures/menu-bar/menu-bar.js'
import './../../components/structures/skip-to-main/skip-to-main.js'

import displayHelloConsoleMessage from './../../vendor/scripts/fabrique/modules/console-hello'
import fireCustomEvent from './../../vendor/scripts/fabrique/modules/fire-custom-event'
import konamiCode from './../../vendor/scripts/fabrique/modules/konami-code'
import preventTransitionsOnResize from './../../vendor/scripts/fabrique/modules/prevent-transitions-on-resize'
import setAllExternalLinksToTargetBlank from './../../vendor/scripts/fabrique/modules/external-links-target-blank'
// import showBrowserUpdateMessage from './../../vendor/scripts/fabrique/modules/browser-update'

// Intersection observer polyfill - about 20kb raw, but we need it for IE11 & Safari
if (!window.IntersectionObserver) {
  require('intersection-observer')
  window.IntersectionObserver.prototype.POLL_INTERVAL = 250 // Time in milliseconds.
}

// Import smooth scroll - for IE 11, Chrome < 61, Firefox < 36, Safari
if (!('scrollBehavior' in document.documentElement.style)) {
  require('smoothscroll-polyfill').polyfill()
}

// Web animations polyfill - about 50kb raw, so only use if you need it
// require('web-animations-js');

displayHelloConsoleMessage('Made with ♥ by TwoKings+Fabrique')
setAllExternalLinksToTargetBlank()
preventTransitionsOnResize()

// TODO: Update this to current browser scope!
/*
showBrowserUpdateMessage({
  vs: {
    // i: 10, // Visible up to IE10
    i: '11.125.16299.0', // Visible up to latest IE10 on Windows 10 as of moment of building
    f: -3, // Visible up to Firefox 3 versions earlier then current
    o: -3, // Visible up to Opera 3 versions earlier then current
    s: 10, // Visible up to Safari 10
    c: -5, // Visible up to Chrome 5 versions earlier then current,
    ios: 10 // Visible up to iOS 10
  },
  api: 4,
  test: false, // Turn this on to test
  insecure: true, // Visible on insecure browsers
  unsupported: true // Visible on browsers unsupported by vendor
})
*/

// There are 4 load events:
// - 'init-immediate': (compiles when the script is loaded; blocks rendering)
// - 'init-load': (on DOMContentLoaded event; does not block rendering)
// - 'init-after-load': (on Load event, slightly after DOMContentLoaded)
// - 'init-delayed-load': (after Load event, with a slight delay, for iframes and such)
// Usually, the 'init-load' event will suffice.
fireCustomEvent('init-immediate')
window.addEventListener('DOMContentLoaded', () => fireCustomEvent('init-load'))
window.addEventListener('load', () => fireCustomEvent('init-after-load'))
window.addEventListener('load', () => window.setTimeout(() => fireCustomEvent('init-delayed-load', 500)))

// Focus stuff
document.addEventListener('keydown', () => document.documentElement.classList.add('key-pressed'))
document.addEventListener('mousedown', () => document.documentElement.classList.remove('key-pressed'))
document.addEventListener('touchstart', () => document.documentElement.classList.remove('key-pressed'))

// Show Neat debug grid on L hotkey and grid on G hotkey when document is focussed.
if (WEBPACK_ENV.ENV === 'development') {
  document.addEventListener('keydown', event => {
    if (event.target !== document.body) {
      return
    }

    if (event.key === 'l') {
      document.documentElement.classList.toggle('debug-layout')
    } else if (event.key === 'g') {
      document.documentElement.classList.toggle('debug-grid')
    }

    document.cookie = `debug-layout=${document.documentElement.classList.contains('debug-layout')}; path=/;`
    document.cookie = `debug-grid=${document.documentElement.classList.contains('debug-grid')}; path=/;`
  })

  document.documentElement.classList.toggle('debug-layout', document.cookie.indexOf('debug-layout=true') !== -1)
  document.documentElement.classList.toggle('debug-grid', document.cookie.indexOf('debug-grid=true') !== -1)
}

konamiCode(function () {
  let dots = []
  let mouse = { x: -250, y: -250 }

  function Dot (i) {
    this.x = 0
    this.y = 0

    const colors = [ 'theme', 'primary', 'secondary', 'orange', 'blue', 'theme' ]
    const color = colors[Math.floor(Math.random() * colors.length)]

    const n = document.createElement('div')
    const o = document.createElement('span')

    n.className = 'balloon'
    n.style.margin = '0'
    n.style.width = (10 + (20 * i)) + 'px'
    n.style.height = (10 + (20 * i)) + 'px'

    o.className = 'balloon__circle'
    o.setAttribute('data-color', color)

    n.appendChild(o)
    document.body.appendChild(n)

    this.node = n
  }

  Dot.prototype.draw = function () {
    this.node.style.transform = `translate3d(${this.x}px, ${this.y}px, 0)`
  }

  for (let i = 0; i < 8; i++) {
    dots.push(new Dot(i + 1))
  }

  function draw () {
    let x = mouse.x
    let y = mouse.y

    dots.forEach(function (dot, index, dots) {
      const nextDot = dots[index + 1] || dots[0]

      dot.x = x
      dot.y = y

      dot.draw()

      x += (nextDot.x - dot.x) * 0.6
      y += (nextDot.y - dot.y) * 0.6
    })
  }

  addEventListener('mousemove', function (event) {
    mouse.x = event.pageX
    mouse.y = event.pageY
  }, { passive: true })

  function animate () {
    draw()
    requestAnimationFrame(animate)
  }

  animate()
})

// Readspeaker Configuration
// This should be set before the readspeaker script is loaded.
/*
window.rsConf = {
  general: {
    usePost: true
  },
  cb: {
    ui: {
      open: function () {
        console.log('[Readspeaker] open')
        // Open all accordions
        for (const element of document.querySelectorAll('.article-accordeon')) {
          element.instance.openAllRegions()
        }
      },
      play: function () {
        console.log('[Readspeaker] play')
      }
    }
  }
}
*/

// Helper for unique ids
function makeid (length) {
  var result = ''
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  var charactersLength = characters.length
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

// Add an `aria-labelledby` to any elements with a `group` role (checkboxes, radios)
document.querySelectorAll('[id^=boltforms] [role="group"]').forEach(function (item) {
  let label = item.querySelector('label')
  let id = label.getAttribute('id')

  if (id === null) {
    id = 'label-' + makeid(5)
    label.setAttribute('id', id)
  }

  item.setAttribute('aria-labelledby', id)
})

// Form errors
document.querySelectorAll('.form-field__error').forEach(function (item) {
  if (item.innerHTML.length > 0) {
    item.closest('.form-field').querySelectorAll('input').forEach(function (input) {
      input.setAttribute('aria-invalid', 'true')
    })
  }
})
